export default __webpack_public_path__ + "static/media/check.7da64643.svg";